import React from 'react';
import Modal from '../../../../components/Modal';
import Input from '../../../../components/Input';
import Textarea from '../../../../components/Textarea';

export default function CategoryModal({ 
  modalCategory, 
  modalTitle, 
  modalDesc, 
  modalError, 
  workItems,
  supabase,
  setModalCategory, 
  setModalTitle, 
  setModalDesc, 
  setModalError,
  setWorkItems 
}) {
  if (!modalCategory) return null;

  return (
    <Modal
      title="Edit Category"
      closeCb={() => {
        setModalCategory(null);
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, minWidth: 320 }}>
        <Input
          value={modalTitle}
          onChange={e => setModalTitle(e.target.value)}
          placeholder="Epic title"
          autoFocus
          left
          style={{ fontWeight: 'normal', textAlign: 'left' }}
          onKeyDown={e => {
            if (e.key === 'Escape') {
              e.stopPropagation();
              setModalCategory(null);
            }
          }}
        />
        <Textarea
          value={modalDesc}
          onChange={e => setModalDesc(e.target.value)}
          placeholder="Notes here..."
          white
          customStyle={{
            color: '#111',
            border: 'none',
            fontFamily: 'inherit',
            fontSize: 14,
            fontWeight: 'normal',
            background: 'transparent',
            textAlign: 'left',
            boxShadow: 'none',
            outline: 'none',
            padding: 0,
            margin: 0,
            marginLeft: 12,
            marginRight: 12,
            resize: 'none',
            minHeight: 28
          }}
          className="modal-notes-dark-placeholder"
        />
        {modalError && <div style={{ color: 'red', fontWeight: 500 }}>{modalError}</div>}
        <div style={{ display: 'flex', gap: 12, marginTop: 8, justifyContent: 'flex-end' }}>
          <button
            style={{ padding: '8px 18px', borderRadius: 5, border: 'none', background: '#27ae60', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}
            onClick={async () => {
              if (!modalTitle.trim()) {
                setModalError('Title cannot be empty');
                return;
              }
              await supabase.from('work').update({ title: modalTitle.trim(), description: modalDesc }).eq('id', modalCategory.id);
              setWorkItems(ws => ws.map(w => w.id === modalCategory.id ? { ...w, title: modalTitle.trim(), description: modalDesc } : w));
              setModalCategory(null);
            }}
          >Save</button>
          {/* Only allow delete if no children */}
          {workItems.filter(w => w.parent_id === modalCategory.id).length === 0 && (
            <button
              style={{ padding: '8px 18px', borderRadius: 5, border: 'none', background: '#e74c3c', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}
              onClick={async () => {
                await supabase.from('work').delete().eq('id', modalCategory.id);
                setWorkItems(ws => ws.filter(w => w.id !== modalCategory.id));
                setModalCategory(null);
              }}
            >Delete</button>
          )}
          <button
            style={{ padding: '8px 18px', borderRadius: 5, border: 'none', background: '#bbb', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}
            onClick={() => {
              setModalCategory(null);
            }}
          >Cancel</button>
        </div>
      </div>
    </Modal>
  );
}

